<script>
import { verifyEmail } from '../api/users';

export default {
  name: 'CpVerifyEmailDialog',
  components: {
    CpButton: require('../button').default,
    CpDialog: require('../dialog').default,
    CpBoxContent: require('../box-content').default,
    CpBox: require('../box').default,
    CpToasted: require('../toasted').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginLeft: require('../directives/margins').marginLeft,
    marginRight: require('../directives/margins').marginRight,
  },
  props: {
    handleDialog: Function,
  },
  data() {
    return {
      loading: false,
      toasted: [],
    };
  },
  methods: {
    handleSendEmail() {
      this.loading = true;
      verifyEmail()
        .then(() => {
          this.createAlert({ message: 'Email sent succesfully' });
        })
        .catch(error => {
          console.warn(error);
          this.createAlert({ message: error.message });
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.handleDialog();
          }, 3000);
        });
    },
    createAlert({ message = '', theme = 'danger', duration = 3000 }) {
      this.toasted.push({ key: `alert-${new Date().toString()}`, message, theme, duration });
    },
  },
};
</script>
<template>
  <CpDialog>
    <div class="alerts">
      <CpToasted v-for="toast in toasted" :key="toast.key" :message="toast.message" :theme="toast.theme" :duration="toast.duration" />
    </div>
    <CpBox>
      <CpBoxContent>
        <div class="sendEmailContainer">
          <i @click.prevent="handleDialog" class="fal fa-times fa-1-5x black-color close-icon"></i>
          <div class="sendEmailData">
            <p class="subheadline1 neutral7-color text-center">One quick step before moving on — Please verify your email.</p>
            <p class="body neutral7-color text-center">Click “Send email” and check your inbox for instructions.</p>
          </div>
          <div class="sendEmailButtons">
            <CpButton @click="handleDialog" block noborder :disabled="loading">Cancel</CpButton>
            <CpButton @click="handleSendEmail" block primary :loading="loading" :disabled="loading">Send email</CpButton>
          </div>
        </div>
      </CpBoxContent>
    </CpBox>
  </CpDialog>
</template>
<style scoped>
.sendEmailContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 50px;
  max-width: 35ch;
  border: 1px solid var(--black);
  position: relative;
}

.close-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
}

.sendEmailData {
  display: flex;
  flex-direction: column;
  padding-bottom: 40px;
}

.sendEmailButtons {
  display: flex;
  justify-content: center;
}

:deep(.button__content) {
  padding: 0.6em 1em !important;
  margin-right: 0 !important;
}
</style>
